import { useTranslation } from 'react-i18next'
import { UIConfigWithDatepicker } from 'views/ElectricityTradingView/components/shared/UIConfigWithDatepicker/UIConfigWithDatepicker'

export default function IntradayOverview() {
  const { t } = useTranslation()

  return <UIConfigWithDatepicker type="intraday_overview" title={t('Intraday overview')} defaultDay="today" />
}
